import config from './config';

export default {
  participant: {
    requestName: 'participant',
    url: `${config.PARTNERS_API.BASE_URL}/${config.PARTNERS_API.ENDPOINTS.PARTICIPANT}`,
  },
  charitySearch: {
    requestName: 'charitySearch',
    url: `${config.PARTNERS_API.BASE_URL}/${config.PARTNERS_API.ENDPOINTS.CHARITY}`,
  },
  fundraisingPage: {
    requestName: 'fundraisingPage',
  },
  donationPage: {
    requestName: 'donationPage',
  },
};



// WEBPACK FOOTER //
// ./config/resources.js